import Vue from 'vue'

Vue.filter('formatDateTime', function (value) {
  if (!value) return ''
  else
    return new Date(value).toLocaleString('nl-NL', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    })
})
Vue.filter('formatDate', function (value) {
  if (!value) return ''
  else
    return new Date(value).toLocaleString('nl-NL', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    })
})
Vue.filter('euro', function (value) {
  return '€ ' + (value / 100).toFixed(2)
})
Vue.filter('eurocent', function (value) {
  return '¢ ' + (value / 10).toFixed(2)
})
Vue.filter('fullName', function (user) {
  if (!user) return '[ missing user ]'
  return (
    user.first_name +
    ' ' +
    (user.insertion ? user.insertion + ' ' : '') +
    user.last_name
  )
})
